import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { Toaster } from "react-hot-toast";
import { afmsWorkspaceSx, cc } from "afms/theme/commandCenterTheme";
import EnergyPortalSidebar from "./EnergyPortalSidebar";

const SIDEBAR_WIDTH = 280;

/**
 * Chrome that wraps the Energy app — a permanent left rail at every
 * viewport size and a flex:1 content column on the right where the
 * routes render. Parallel to LcpPortalShell + EnvironmentalPortalShell;
 * mounted ONCE at the App.js level when pickSidebarVariant returns
 * "energyPortal".
 */
function EnergyPortalShell({ children, onSwitchSystem }) {
  return (
    <Box
      className="energy-portal-shell"
      sx={{
        ...afmsWorkspaceSx,
        display: "flex",
        minHeight: "100vh",
        bgcolor: cc.page,
        color: cc.ink,
      }}
    >
      <Box
        sx={{
          width: SIDEBAR_WIDTH,
          flexShrink: 0,
          borderRight: "1px solid rgba(255,255,255,0.08)",
          // Tinted dark background matches the gradient inside the
          // EnergyPortalSidebar so there's no seam where the rail starts.
          bgcolor: "#1a1612",
          position: "sticky",
          top: 0,
          alignSelf: "flex-start",
          height: "100vh",
          overflowY: "auto",
        }}
      >
        <EnergyPortalSidebar onSwitchSystem={onSwitchSystem} />
      </Box>
      <Box
        sx={{
          minWidth: 0,
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </Box>
      <Toaster />
    </Box>
  );
}

EnergyPortalShell.propTypes = {
  children: PropTypes.node,
  onSwitchSystem: PropTypes.func,
};

export default EnergyPortalShell;
